import TySearch from './TySearch.vue'
export default TySearch



// WEBPACK FOOTER //
// ./src/components/ty-search/index.js